import React from 'react'
import { Box, Typography, Link } from '@material-ui/core'
import { themeConWeb } from '../../util/modernThemeConweb'

const AccountWidget = ({ title, name, classes, manageLink, showManageLink }) => (
  <Box display="flex" flexDirection="column" alignItems="start" marginY={3}>
    <Typography variant="subtitle2" color="textSecondary">
      {title}
    </Typography>
    <Typography variant="h6">{name}</Typography>
    {showManageLink ? (
      <Typography className={classes.manageButton} color={themeConWeb.color.dangerLight}>
        <Link href={manageLink}>Manage</Link>
      </Typography>
    ) : null}
  </Box>
)

export default AccountWidget
